export default {
  data() {
    return {
      reloadTimeout: null,
    };
  },
  methods: {
    startTimer() {
      this.reloadTimeout = setInterval(() => {
        this.onRefresh();
      }, 300000); // 5 minutes
    },
    resetTimer() {
      if (this.reloadTimeout) {
        clearTimeout(this.reloadTimeout);
      }
    },
  },
  created() {
    this.startTimer();
  },
  destroyed() {
    this.resetTimer();
  },
};



// WEBPACK FOOTER //
// ./src/mixins/refreshPageMixin.js